const apis = {}
// #ifndef VUE3
const moduleFiles = require.context('../api/*.js', true, /\.js$/);
moduleFiles.keys().forEach(it => {
	const name = it.substring(2, it.length - 3)
	apis[name] = moduleFiles(it)
})
// #endif

// #ifdef VUE3
const moduleFiles = import.meta.glob('../api/*.js',{ eager: true })
Object.keys(moduleFiles).forEach(it => {
	const name = it.substring(it.lastIndexOf('/') + 1, it.length - 3).replace('api/', '')
	apis[name] = moduleFiles[it]
})
// #endif

export {
	apis
}
